import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './TauriNavigation.css';
import TauriUserView from '../TauriUserView/TauriUserView';
import TauriSearchBox from '../TauriSearchBox/TauriSearchBox';
import TauriBrand from '../TauriBrand/TauriBrand';
import TauriApplicationMenuItems from '../TauriApplicationMenuItems/TauriApplicationMenuItems';
import TauriImage from '../TauriImage/TauriImage';
import OpalConnectionStatus from './OpalConnectionStatus/OpalConnectionStatus';
import { ApplicationBrand, MenuItems } from '../../client-configuration';

const TauriNavigation = () => {
  const [userViewData, setUserViewData] = useState([]);

  useEffect(() => {
    // Get user data from localStorage
    const usr = localStorage.getItem('name');

    const title = localStorage.getItem('title');

    const userInfo = {
      name: usr || '',
      title: title
    };
    setUserViewData(userInfo);
  }, []);


  return (
    <header className="navbar sticky-top flex-md-nowrap px-2 px-md-0">
      <button
        className="navbar-toggler d-md-none collapsed me-2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <TauriImage
          localImage={"/Images/hamburger-white.svg"}
          className={"navbar-toggler-icon"}
          color={"#FFF"}
          alt="Toggle"
        />
      </button>

      <TauriBrand brand={ApplicationBrand} />

      <div className="d-flex align-items-center ms-auto order-2 order-md-3">
        <TauriImage
          localImage={"/Images/tabler--bell.svg"}
          className="nav-icon"
          alt="icon"
          color="#FFFFFF"
        />
        <OpalConnectionStatus />
        <TauriUserView fullname={userViewData.name} title={userViewData.title} />
      </div>

      <div className="order-3 order-md-2 w-100">
        <TauriApplicationMenuItems items={MenuItems.applicationItem.data.item} />
      </div>
    </header>

  );
};

export default TauriNavigation;
